







import { Type as IndicatorsType } from '@solucx/indicators';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ClassItem from '../../../models/interfaces/ClassItem';
import ClassItemRate from '../../../models/interfaces/ClassItemRate';
import { ClassRatingLike } from '../../../utils/ClassRatingLike';
import Buttons from '../../ScoreInput/Buttons.vue';

@Component({ components: { Buttons } })
export default class ClassLikeDislike extends Vue {
  @Prop({ required: true })
  public readonly item!: ClassItem;

  @Prop({ required: true })
  public readonly value!: ClassItemRate;

  @Watch('value.score')
  public updateLike(score: number) {
    this.value.like = ClassRatingLike.getRatingLike(score, IndicatorsType.NPS);
    this.$emit('input', this.value);
  }
}
